import React, { useState, useEffect, Fragment } from 'react';
import propTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import $ from 'jquery'

const headers = [
  'Ticket Id',
  'User Name',
  'User Email',
  'User Number',
  // 'Complain Type',
  'Created On',
  'Internal Status',
  'Actions',
];


const RaiseIssue = ({ 
    rmTicketFilter,
    getRmTicketsFilterDropDown,
    fetchAllIssuesList,
    getAllIssuesListing = []
}) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);


  useEffect(() => {
    const tableData = [
      'id',
      'user_name',
      'user_email',
      'phone_number',
      // 'complain_type',
      'created_at',
      'internal_status'
    ];

    if (getAllIssuesListing && getAllIssuesListing?.resultSets?.length > 0) {
      const data = getAllIssuesListing?.resultSets?.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ( 
            (key === 'internal_status' && element[key] === 'l2_pending') ? {[key]:'L2 Pending'}
            : { [key]: element[key] })),
          {
            Actions: {
              name: 'View Complain',
              link: `/dashboard/view-issue/${element.id}`,
              item: element,
            },
          }
        )
      );
      if (data && data?.length >0) {
        setListData(data);
        setPageCount(Math.ceil(getAllIssuesListing?.total / getAllIssuesListing?.per_page));
        setCurrentPage(getAllIssuesListing?.current_page);
      }
    }else{
      setListData([]);
    }

  }, [getAllIssuesListing]);
  useEffect(() => {
    $('.modal-backdrop').remove();
    const installationCont = JSON.parse(
      localStorage.getItem("complaintCont") &&
        localStorage.getItem("complaintCont")
    );
    if(installationCont){
      localStorage.setItem("complaintList", JSON.stringify(""));
      localStorage.setItem("complaintCont", 0);
    }
    
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getcontractFilter = await JSON.parse(
        localStorage.getItem("complaintList") &&
          localStorage.getItem("complaintList")
      );
      if(getcontractFilter){
        await fetchAllIssuesList(getcontractFilter);
      }else{
        await fetchAllIssuesList();
      }
      
      await getRmTicketsFilterDropDown();
      setIsLoading(false);
    })();
  }, [fetchAllIssuesList]);

  

  const applyFilter = async (filterData) => {
    // console.log(filterData);
    localStorage.setItem("complaintList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchAllIssuesList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await fetchAllIssuesList(filter,val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
  };


  return (
    <Layout 
        title={'LeadX Ticket List'} 
        isLoading={isLoading} 
        Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        // isId={false}
        headers={headers}
        detailList={getAllIssuesListing}
        pageCount={pageCount}
        srNo={getAllIssuesListing?.from}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
      
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId=''
        // statusId={3}
        listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
        rmTicketFilter
        complaintFilter = {true}
      />
    </Layout> 
  );
};

RaiseIssue.propTypes = {
    fetchAllIssuesList: propTypes.func,
};

export default RaiseIssue;
